import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const QRRedirect = ({ to = '/how-to-take' }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (/^https?:\/\//i.test(to)) {
      window.location.replace(to);
    } else {
      navigate(to, { replace: true });
    }
  }, [navigate, to]);
  return null;
};

export default QRRedirect;
